const initialData = {
  team: [],
  paste: "",
  matchups: [],
};

export default initialData;
